import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";

const initialState: any = {
  serviceTypes: null,
  serviceTypesCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  offset: 0,
};

export const serviceTypesSlice = createSlice({
  name: "serviceTypes",
  initialState,
  reducers: {
    reducerGetServiceTypes: (state: Draft<any>, action: PayloadAction<any>) => {
      state.serviceTypes = action.payload.data.data || [];
      state.serviceTypesCount = action.payload.data.count;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
    },
    reducerGetServiceTypesSelect: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.selectContact = action.payload.data;
      state.selectContactOptions = action.payload.data.data.map((el: any) => ({
        label: el.name,
        value: el.id,
      }));
      const temp: any = {};
      action.payload.data.data.map((el: any) => (
                temp[el.id] = el.name
      ));
      state.selectContactById = temp;
    },
    reducerServiceTypesStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.serviceStatus = action.payload;
    },
    reducerServiceTypesClear: () => {
      return initialState;
    }
  },
});

export const {
  reducerGetServiceTypesSelect,
  reducerServiceTypesStatus,
  reducerGetServiceTypes,
  reducerServiceTypesClear,
} = serviceTypesSlice.actions;

export default serviceTypesSlice.reducer;
